/**
 * @fileoverview Click&Pledge indicator component for the conference header.
 * Provides a clickable donate button that toggles the Click&Pledge interface visibility.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Icon, IconClickandPledge } from '../../../base/icons';
import { isClickandPledge } from '../../actions';

/**
 * Click&Pledge indicator component for the conference header.
 * Displays a donate button that toggles the Click&Pledge interface
 * and closes other panels when activated.
 *
 * @param {Object} props - Component props
 * @param {boolean} props._isClickandPledgeEnabled - Current Click&Pledge enabled state
 * @returns {ReactElement} The donate indicator button
 */
function ClickPledgeIndicator({ _isClickandPledgeEnabled }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    /**
     * Toggles the Click&Pledge interface visibility.
     * Also closes participants pane and chat when opening Click&Pledge.
     */
    const toggleClickandPledge = () => {
        dispatch(isClickandPledge(!_isClickandPledgeEnabled));
    };

    return (
        <div
            className = 'clickpledge-indicator'
            onClick = { toggleClickandPledge }>
            <Icon src = { IconClickandPledge } />
            <span>{t('clickandpledge.donate')}</span>
        </div>
    );
}

export default ClickPledgeIndicator;
